import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-track-my-workout',
  templateUrl: './track-my-workout.component.html',
  styleUrls: ['./track-my-workout.component.css']
})
export class TrackMyWorkoutComponent implements OnInit {
  public workoutName = '';
  public sets: number;
  public reps: number;
  public weight: number;
  public rows: Array<{ workoutName: string, sets: number, reps: number, weight: number }> = [];

  constructor() { }

  ngOnInit(): void {
  }

  // Adds exercise to the table
  AddExercise() {
    this.rows.push({ workoutName: this.workoutName, reps: this.reps, sets: this.sets, weight: this.weight });

    this.workoutName = null;
    this.sets = null;
    this.reps = null;
    this.weight = null;
  }

  //Removes Exercise From Table
  RemoveExercise(row: { workoutName: string; sets: number; reps: number; weight: number; }) {
    const index = this.rows.indexOf(row);
    this.rows.splice(index, 1);
  }

  // Clears all exercises from the table
  ClearExercise() {
    this.rows = [];
  }

}
